/******************************************************************************\
 * :$
 *
 * Copyright(c) 2022 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: Admin
 *
 * Purpose:
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 11Jan2022 craig File created.
 \******************************************************************************/
import React, {useRef} from "react";
import "./Admin.css";
import {Container, Nav, Navbar, Row} from "react-bootstrap";
import {NavLink, useParams} from "react-router-dom";
import {Teams} from "./Teams";
import {Users} from "./Users";

export const Admin: React.FC = (props) => {

    const {adminSection} = useParams();

    const navElement = useRef<HTMLDivElement>(null);

    const AdminNavigation = () => {
        return <Navbar>
            <Container>
                <Nav ref={navElement} className={"admin-nav-bar"}>
                    <NavLink id={"Users"} className={"nav-link active-admin"} to={"/admin/users"}>Users</NavLink>
                    <NavLink id={"Teams"} className={"nav-link"} to={"/admin/teams"}>Teams</NavLink>
                </Nav>
            </Container>
        </Navbar>
    }

    const AdminSection = () => {
        let tmpSection:string = "USERS";
        if (adminSection === null || adminSection === undefined) {
            tmpSection = "USERS";
        }
        else {
            tmpSection = adminSection.toUpperCase();
        }
        if (tmpSection === "USERS") {
            return <Users/>
        }
        else if (tmpSection === "TEAMS") {
            return <Teams/>
        }
        return <Users/>
    }

    return <Container className="form-container" fluid>
        <Row>
            {AdminNavigation()}
        </Row>
        <Row>
            {AdminSection()}
        </Row>
    </Container>
}

